import { useCart, useCartCount, useSettings } from '@backpackjs/storefront';

let beamCart;

export function useBeamCartUpdate() {
  const cart = useCart();
  const cartCount = useCartCount();
  const settings = useSettings();
  const beamSettings = settings?.beam;

  const cartChangeTrigger = async () => {
    beamCart =
      beamCart ||
      (await import(
        /* webpackIgnore: true */
        'https://sdk.beamimpact.com/web-sdk/v1.53.1/dist/integrations/cart.esm.js'
      ));

    const { updateCart } = beamCart;

    const BeamConfig = {
      apiKey: beamSettings.beamApiKey,
      storeId: parseInt(beamSettings.beamStoreId, 10),
      baseUrl: 'https://api.beamimpact.com',
      domain: 'clearlyfiltered.com',
    };

    const data = {
      cartId: cart.id,
      currencyCode: cart?.estimatedCost?.subtotalAmount?.currencyCode,
      itemCount: cartCount,
      subtotal: parseFloat(cart?.estimatedCost?.subtotalAmount?.amount || 0),
    };

    await updateCart(BeamConfig, data);
  };

  return { cartChangeTrigger };
}
